<mat-spinner *ngIf="!application || isRefreshing" class="loading" color="primary"/>
<mat-card *ngIf="application && !isRefreshing" class="content-card m-2">
    <mat-card-header>
        <mat-card-title>Banking Configuration</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="row">

            <form [formGroup]="bankingForm" novalidate class="col-8">
                <div class="row">
                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Banking method</mat-label>
                        <mat-select formControlName="bankingMethod" (selectionChange)="onBankingMethodChange($event.value)">
                            <mat-option value="Inverite">
                                Inverite
                            </mat-option>
                            <mat-option value="Flinks">
                                Flinks
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="col-6" [hidden]="application.Co_Appl_Required === 'No'">
                        <mat-label>Select applicant</mat-label>
                        <mat-select formControlName="applicant">
                            <mat-option value="MAIN_APPLICANT">
                                Main applicant
                            </mat-option>
                            <mat-option value="CO_APPLICANT">
                                Co applicant
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
            <form [formGroup]="inveriteForm" novalidate class="col-4"
                  [hidden]="bankingForm.controls.bankingMethod.value !== 'Inverite'">
                <mat-form-field appearance="outline" class="col-12">
                    <mat-label>Select your bank</mat-label>
                    <mat-select formControlName="bank">
                        <mat-option style="background-color: white;">
                            <ngx-mat-select-search [formControl]="inveriteBanksFilter"
                                                   placeholderLabel="Search occupations"
                                                   noEntriesFoundLabel="No matching occupations found"/>
                        </mat-option>
                        <mat-option *ngFor="let option of filteredInveriteBanks | async" [value]="option.bankID">
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>

        <div class="col d-flex gap-2 my-2 align-items-center">
            <button mat-raised-button color="primary" (click)="createInveriteRequest()"
                    [hidden]="bankingForm.controls.bankingMethod.value !== 'Inverite'"
                    [disabled]="inveriteForm.invalid">Request
            </button>
            <button mat-raised-button color="primary" (click)="createFlinksRequest()"
                    [hidden]="bankingForm.controls.bankingMethod.value !== 'Flinks'">Request
            </button>
            <button mat-button color="primary"
                    (click)="refreshRequests(application.id)"
                    [disabled]="isRefreshing">
                <mat-icon *ngIf="!isRefreshing">refresh</mat-icon>
                Refresh
            </button>
            <mat-spinner *ngIf="isRefreshing" diameter="24" color="primary"></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>
<mat-card *ngIf="application && !isRefreshing" class="content-card m-2 mt-4">
    <mat-card-header>
        <mat-card-title>Banking Requests</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table mat-table [dataSource]="dataSourceInveriteRequest" class="flat-table"
               [hidden]="bankingForm.controls.bankingMethod.value !== 'Inverite'">
            <ng-container matColumnDef="bank">
                <th mat-header-cell *matHeaderCellDef>Bank</th>
                <td mat-cell *matCellDef="let inveriteRequest">
                    {{ getBankNameFromId(inveriteRequest.bankId) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="applicant">
                <th mat-header-cell *matHeaderCellDef>Applicant</th>
                <td mat-cell *matCellDef="let inveriteRequest">
                    {{ getApplicant(inveriteRequest.applicant) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let inveriteRequest">{{ inveriteRequest.status }}</td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let inveriteRequest">
                    <button mat-icon-button color="primary"
                            [disabled]="inveriteRequest.status !== 'Verified'"
                            (click)="viewBankStatement(inveriteRequest)"
                            [style.opacity]="inveriteRequest.status === 'Verified' ? 1 : 0.5">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button color="warn"
                            (click)="deleteInveriteRequest(inveriteRequest.inveriteId)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsInveriteRequest"></tr>
            <tr mat-row *matRowDef="let inveriteRequest; columns: displayedColumnsInveriteRequest">
            </tr>
        </table>

        <table mat-table [dataSource]="dataSourceFlinksRequest" class="flat-table content-table"
               [hidden]="bankingForm.controls.bankingMethod.value !== 'Flinks'">
            <ng-container matColumnDef="applicant">
                <th mat-header-cell *matHeaderCellDef>Applicant</th>
                <td mat-cell *matCellDef="let flinksRequest">{{ getApplicant(flinksRequest.applicant) }}</td>
            </ng-container>

<!--            TODO: Until firewall is fixed-->
<!--            <ng-container matColumnDef="status">-->
<!--                <th mat-header-cell *matHeaderCellDef>Status</th>-->
<!--                <td mat-cell *matCellDef="let flinksRequest">{{ flinksRequest.status }}</td>-->
<!--            </ng-container>-->

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let flinksRequest">N/A</td>
            </ng-container>

            <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef>View bank statement</th>
                <td mat-cell *matCellDef="let flinksRequest">
                    <button mat-icon-button color="primary"
                            (click)="viewBankStatementOnFlinks(flinksRequest)">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsFlinksRequest"></tr>
            <tr mat-row *matRowDef="let flinksRequest; columns: displayedColumnsFlinksRequest"></tr>
        </table>
    </mat-card-content>
</mat-card>
<mat-card *ngIf="application && showBankStatement" class="content-card m-2 mt-4">
    <mat-card-header class="d-flex align-items-center">
        <mat-card-title>Bank Statement</mat-card-title>
        <button mat-icon-button color="primary" (click)="closeBankStatement()" class="ms-auto">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>

        <div *ngIf="homeFlag">
            <mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)">
                <div>
                    <mat-tab *ngFor="let acc of accounts; let index = index"
                             [label]="account_labels[index] | uppercase">
                        <div class="row">
                            <div class="col-4 col-md-4 col-sm-12">
                                <mat-card class="content-card">
                                    <mat-card-header>
                                        <mat-card-title>Detected Account</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="info-row">
                                            <span class="label">Bank:</span>
                                            <span class="value">{{ acc.bank }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Institution:</span>
                                            <span class="value">{{ acc.institution }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Transit:</span>
                                            <span class="value">{{ acc.transit }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Account:</span>
                                            <span class="value">{{ acc.account }}</span>
                                        </div>
                                        <div class="info-row"
                                             *ngIf="hasProperties(acc.current_balance)">
                                            <span class="label">Current Balance:</span>
                                            <span class="value">{{ acc.current_balance }}</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-8 col-md-8 col-sm-12" *ngIf="hasProperties(acc.statistics)">
                                <mat-card class="content-card">
                                    <mat-card-header>
                                        <mat-card-title>Monthly Transaction Summary
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <table class="flat-table">
                                            <thead>
                                            <tr>
                                                <th>Date Range</th>
                                                <th>Food</th>
                                                <th>Utilities</th>
                                                <th>Auto</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let item of monthlyTransactionSummary(index)">
                                                <td class="date-cell">{{ item['start'] }}-{{ item['end'] }}</td>
                                                <td>{{ formatCurrency($safeNavigationMigration(item?.['result']?.['food_and_dining_debit_total'])) }}</td>
                                                <td>{{ formatCurrency($safeNavigationMigration(item?.['result']?.['bills_and_utilities_debit_total'])) }}</td>
                                                <td>{{ formatCurrency($safeNavigationMigration(item?.['result']?.['auto_and_transport_debit_total'])) }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                        <br/>
                        <mat-tab-group>
                            <mat-tab label="Account Statistics">
                                <div *ngIf="hasProperties(acc.statistics)">
                                    <table class="flat-table content-table">
                                        <thead>
                                        <tr>
                                            <th class="metric-column">Metric</th>
                                            <th>3 Months</th>
                                            <th>6 Months</th>
                                            <th>9 Months</th>
                                            <th>12 Months</th>
                                            <th>All Time</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <!-- NSF Statistics -->
                                        <tr class="section-header warning-section">
                                            <td colspan="6">NSF (Non-Sufficient Funds)</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Number Of NSF</td>
                                            <td>{{ acc.statistics.quarter_3_months?.number_of_nsf || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.number_of_nsf || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.number_of_nsf || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.number_of_nsf || '0' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.number_of_nsf || '0' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Number NSF</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_3_months?.average_number_nsf)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_6_months?.average_number_nsf)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_9_months?.average_number_nsf)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_12_months?.average_number_nsf)) }}</td>
                                            <td class="highlight-cell">{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_all_time?.average_number_nsf)) }}</td>
                                        </tr>

                                        <!-- Overdraft Statistics -->
                                        <tr class="section-header warning-section">
                                            <td colspan="6">Overdraft</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Highest Overdraft</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.highest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.highest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.highest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.highest_overdraft)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.highest_overdraft)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Lowest Overdraft</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.lowest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.lowest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.lowest_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.lowest_overdraft)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.lowest_overdraft)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Number Of Overdraft</td>
                                            <td>{{ acc.statistics.quarter_3_months?.number_of_overdraft || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.number_of_overdraft || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.number_of_overdraft || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.number_of_overdraft || '0' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.number_of_overdraft || '0' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Amount Overdraft</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.average_amount_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.average_amount_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.average_amount_overdraft)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.average_amount_overdraft)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.average_amount_overdraft)) }}</td>
                                        </tr>

                                        <!-- Deposit Statistics -->
                                        <tr class="section-header">
                                            <td colspan="6">Deposits</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Number Of Deposit</td>
                                            <td>{{ acc.statistics.quarter_3_months?.number_of_deposit || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.number_of_deposit || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.number_of_deposit || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.number_of_deposit || '0' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.number_of_deposit || '0' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Amount Of Deposit</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.amount_of_deposit)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.amount_of_deposit)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Amount Of Deposit</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.average_amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.average_amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.average_amount_of_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.average_amount_of_deposit)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.average_amount_of_deposit)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Number Of Deposit</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_3_months?.average_number_of_deposit)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_6_months?.average_number_of_deposit)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_9_months?.average_number_of_deposit)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_12_months?.average_number_of_deposit)) }}</td>
                                            <td class="highlight-cell">{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_all_time?.average_number_of_deposit)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Highest Deposit</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.highest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.highest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.highest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.highest_deposit)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.highest_deposit)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Lowest Deposit</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.lowest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.lowest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.lowest_deposit)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.lowest_deposit)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.lowest_deposit)) }}</td>
                                        </tr>

                                        <!-- Withdrawal Statistics -->
                                        <tr class="section-header">
                                            <td colspan="6">Withdrawals</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Number Of Withdrawal</td>
                                            <td>{{ acc.statistics.quarter_3_months?.number_of_withdrawal || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.number_of_withdrawal || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.number_of_withdrawal || '0' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.number_of_withdrawal || '0' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.number_of_withdrawal || '0' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Amount Of Withdrawal</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.amount_of_withdrawal)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.amount_of_withdrawal)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Amount Of Withdrawal</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.average_amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.average_amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.average_amount_of_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.average_amount_of_withdrawal)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.average_amount_of_withdrawal)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Number Of Withdrawal</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_3_months?.average_number_of_withdrawal)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_6_months?.average_number_of_withdrawal)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_9_months?.average_number_of_withdrawal)) }}</td>
                                            <td>{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_12_months?.average_number_of_withdrawal)) }}</td>
                                            <td class="highlight-cell">{{ formatNumber($safeNavigationMigration(acc.statistics.quarter_all_time?.average_number_of_withdrawal)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Highest Withdrawal</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.highest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.highest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.highest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.highest_withdrawal)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.highest_withdrawal)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Lowest Withdrawal</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.lowest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.lowest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.lowest_withdrawal)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.lowest_withdrawal)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.lowest_withdrawal)) }}</td>
                                        </tr>

                                        <!-- Balance Statistics -->
                                        <tr class="section-header">
                                            <td colspan="6">Balance</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Highest Balance</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.highest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.highest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.highest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.highest_balance)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.highest_balance)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Lowest Balance</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.lowest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.lowest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.lowest_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.lowest_balance)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.lowest_balance)) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Average Balance</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_3_months?.average_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_6_months?.average_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_9_months?.average_balance)) }}</td>
                                            <td>{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_12_months?.average_balance)) }}</td>
                                            <td class="highlight-cell">{{ formatCurrency($safeNavigationMigration(acc.statistics.quarter_all_time?.average_balance)) }}</td>
                                        </tr>

                                        <!-- Transaction Date Range -->
                                        <tr class="section-header">
                                            <td colspan="6">Transaction</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Oldest Transaction</td>
                                            <td>{{ acc.statistics.quarter_3_months?.oldest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.oldest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.oldest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.oldest_transaction || 'n/a' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.oldest_transaction || 'n/a' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="metric-label">Newest Transaction</td>
                                            <td>{{ acc.statistics.quarter_3_months?.newest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_6_months?.newest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_9_months?.newest_transaction || 'n/a' }}</td>
                                            <td>{{ acc.statistics.quarter_12_months?.newest_transaction || 'n/a' }}</td>
                                            <td class="highlight-cell">{{ acc.statistics.quarter_all_time?.newest_transaction || 'n/a' }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </mat-tab>
                            <mat-tab label="Transactions">
                                <div *ngIf="hasProperties(acc.transactions)">
                                    <table class="flat-table inverite-table">
                                        <thead>
                                        <tr>
                                            <th class="text-left">Date</th>
                                            <th class="text-left">Description</th>
                                            <th>Debit</th>
                                            <th>Credit</th>
                                            <th>Balance</th>
                                            <th>Category</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let pays of acc.transactions">
                                            <td class="text-left date-cell">{{ pays.date }}</td>
                                            <td class="text-left">{{ pays.details }}</td>
                                            <td>{{ pays.debit }}</td>
                                            <td>{{ pays.credit }}</td>
                                            <td>{{ pays.balance }}</td>
                                            <td>{{ pays.category }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-tab>
                </div>
            </mat-tab-group>
        </div>


        <div *ngIf="!homeFlag" class="loading-container">
            <mat-spinner color="primary"></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>
